/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Auto_NoteInputs */

const en_mk_build_auto_note = /** @type {(inputs: Mk_Build_Auto_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For projects supported by automatic mode. Usage depends on your allowance and AI connection.`)
};

const id_mk_build_auto_note = /** @type {(inputs: Mk_Build_Auto_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk proyek yang didukung mode otomatis. Penggunaan mengikuti kuota dan koneksi AI.`)
};

/**
* | output |
* | --- |
* | "For projects supported by automatic mode. Usage depends on your allowance and AI connection." |
*
* @param {Mk_Build_Auto_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_auto_note = /** @type {((inputs?: Mk_Build_Auto_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Auto_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_auto_note(inputs)
	return en_mk_build_auto_note(inputs)
});